import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var CsToggleuserpreferenceService = /** @class */ (function () {
    function CsToggleuserpreferenceService() {
        this.eventSubject = new Subject();
    }
    CsToggleuserpreferenceService.prototype.emit = function (data) {
        this.eventSubject.next(data);
    };
    CsToggleuserpreferenceService.prototype.onEvent = function () {
        return this.eventSubject.asObservable();
    };
    CsToggleuserpreferenceService.ngInjectableDef = i0.defineInjectable({ factory: function CsToggleuserpreferenceService_Factory() { return new CsToggleuserpreferenceService(); }, token: CsToggleuserpreferenceService, providedIn: "root" });
    return CsToggleuserpreferenceService;
}());
export { CsToggleuserpreferenceService };
